// Fetch Request
import fetch from '../../../core/fetch';
// Redux
import { closeListSettingsModal } from '../../../actions/siteadmin/modalActions';
import { getAdminListingSettings } from '../../../actions/siteadmin/getAdminListingSettings';
import showToaster from '../../../helpers/toasterMessages/showToaster';

async function submit(values, dispatch) {
  let dynamicItemName = values?.dynamicItemName?.length > 0 ? JSON.stringify(values.dynamicItemName) : JSON.stringify([]);

  const query = `
    query (
        $typeId:Int,
        $itemName:String,
        $itemDescription:String,
        $otherItemName:String,
        $maximum:Int,
        $minimum:Int,
      	$startValue:Int,
        $endValue:Int,
        $isEnable: String,
        $makeType: String,
        $dynamicItemName: String,
      ) {
          addListSettings (
            typeId:$typeId,
            itemName:$itemName,
            itemDescription:$itemDescription,
            otherItemName:$otherItemName,
            maximum: $maximum,
            minimum: $minimum,
            startValue: $startValue,
            endValue: $endValue,
            isEnable: $isEnable,
            makeType: $makeType,
            dynamicItemName: $dynamicItemName
          ) {
            status
          }
        }
  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: {
        typeId: values?.typeId,
        itemName: values?.itemName,
        itemDescription: values?.itemDescription,
        otherItemName: values?.otherItemName,
        maximum: values?.maximum,
        minimum: values?.minimum,
        startValue: values?.startValue,
        endValue: values?.endValue,
        isEnable: values?.isEnable,
        makeType: values?.makeType,
        dynamicItemName: dynamicItemName
      }
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data?.addListSettings?.status === "success") {
    dispatch(closeListSettingsModal());
    await dispatch(getAdminListingSettings(values.typeId));
    showToaster({ messageId: 'listSettingsSuccess', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'listSettingsFailed', toasterType: 'error' })
    dispatch(closeListSettingsModal());
  }

}

export default submit;
